import React, { useState } from 'react'

import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import FilterListIcon from '@mui/icons-material/FilterList'
import { Grid, IconButton } from '@mui/material'
import debounce from 'lodash/debounce'

import { FormTextField } from 'components/input'
import { INITIAL_COMPANIES_FILTERS } from 'constants/companies-filters'
import { withForm } from 'decorators/withForm'

import CompaniesFiltersModal from './CompaniesFiltersModal'
import CompaniesUploadCSVModal from './CompaniesUploadCSVModal'

const MODALS = {
  filterModal: 'filterModal',
  csvModal: 'csvModal',
}

type CompaniesFiltersProps = {
  count?: number
  initialValues?: Record<string, any>
  onExport: (format: any) => any
  reset: (...args: any[]) => any
  setFilters: (...args: any[]) => any
}

const CompaniesFilters = ({ count, onExport, reset, setFilters }: CompaniesFiltersProps) => {
  const [openModal, setOpenModal] = useState<string | null>(null)

  const handleModalClose = () => setOpenModal(null)

  const handleReset = () => {
    setFilters(INITIAL_COMPANIES_FILTERS)
    reset(INITIAL_COMPANIES_FILTERS)
    handleModalClose()
  }

  const handleExport = (format: any) => async () => {
    await onExport(format)
    handleModalClose()
  }

  return (
    <Grid container spacing={2} style={{ width: 800 }} sx={{ alignItems: 'center' }}>
      <Grid
        size={{
          sm: 7,
        }}
      />
      <Grid
        size={{
          sm: 3,
        }}>
        <FormTextField name="search" placeholder="Search..." />
      </Grid>
      <Grid
        size={{
          sm: 1,
        }}>
        <IconButton aria-label="Filter list" onClick={() => setOpenModal(MODALS.filterModal)} size="large">
          <FilterListIcon />
        </IconButton>
      </Grid>
      <Grid
        size={{
          sm: 1,
        }}>
        <IconButton aria-label="Upload CSV" onClick={() => setOpenModal(MODALS.csvModal)} size="large">
          <CloudUploadIcon />
        </IconButton>
      </Grid>
      <CompaniesFiltersModal
        count={count}
        onClose={handleModalClose}
        onExport={handleExport}
        onReset={handleReset}
        open={openModal === MODALS.filterModal}
      />
      <CompaniesUploadCSVModal onClose={handleModalClose} open={openModal === MODALS.csvModal} />
    </Grid>
  )
}

export default withForm({
  form: 'companiesFilters',
  initialValues: INITIAL_COMPANIES_FILTERS,
  onChange: debounce((values: any, _dispatch: any, props: any) => props.setFilters(values), 500),
})(CompaniesFilters)
